import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { getInitialItems } from '../../selectors';
import LocationsInput from '../../components/SearchBar/LocationsInput';

export default connect(
  createStructuredSelector({
    initialItems: getInitialItems,
  }),
)(LocationsInput);
